export default {
  "Update case success": "پرونده با موفقیت به روز شد",
  ru: "RU",
  en: "EN",
  languages: {
    ru: "روسی",
    en: "انگلیسی",
    ar: "عربی",
    es: "اسپانیایی",
    fa: "فارسی",
    kz: "قزاقی",
    pt: "پرتغالی",
    fr: "فرانسوی",
  },
  CoursesTitle: "دوره‌ها | " + process.env.VUE_APP_INSTALL_NAME + "",
  Module_AI: {
    title: "هوش مصنوعی",
    desc: "تحلیل تصاویر پزشکی با استفاده از خدمات هوش مصنوعی",
  },
  Module_edu: {
    title: "آموزش",
    desc: "شبیه‌سازهای دیداری، دوره‌ها و مطالب مفید برای پزشکان",
  },
  Module_community: {
    title: "انجمن",
    desc: "تبادل دانش بین پزشکان، بحث درباره موارد بالینی",
  },
  Profile: "پروفایل",
  Subscription: "اشتراک",
  "Go to site": "رفتن به سایت",
  "Access after pay": "درس هنوز باز نشده است",
  Exit: "خروج",
  MY: "پروفایل من",
  Home: "صفحه اصلی",
  "Mobile banner text : demo":
    "یک حساب کاربری ایجاد کنید و به خدمات هوش مصنوعی و شبیه‌سازها دسترسی کامل پیدا کنید",
  Platform: "پلتفرم پزشکان",
  "Platform info":
    "دستیارهای هوش مصنوعی، شبیه‌سازهای دیداری، دوره‌ها و مطالب مفید برای پزشکان",
  "Download app": "دانلود برنامه",
  "Home title": "پلتفرم پزشکان | " + process.env.VUE_APP_INSTALL_NAME + "",
  AI: "هوش مصنوعی",
  edu: "آموزش",
  community: "انجمن",
  "Your courses": "دوره‌های شما",
  "Recomended courses": "دوره‌های پیشنهادی",
  Courses: "دوره‌ها",
  Calculator: "ماشین حساب",
  Plug: "اتصال",
  "Go to": "رفتن",
  Case: "مورد",
  Cases: "موارد",
  "Case success": "تکمیل شده",
  "Case unsuccess": "تکمیل نشده",
  Modality: "مدالیتی",
  "Page title tail": " | " + process.env.VUE_APP_INSTALL_NAME + "",
  "Cant find service?": "سرویس مورد نظر را پیدا نکردید؟",
  "Text us": "برای ما بنویسید",
  "I need AI for...": "من به سرویس هوش مصنوعی برای ... نیاز دارم",
  "Thx for reply": "با تشکر از پیشنهاد شما!",
  Send: "ارسال",
  Sent: "ارسال شد",
  "Cannot loading reply -- adblock":
    "ارسال نشد. لطفاً افزونه‌های مرورگر مانند VPN یا مسدودکننده تبلیغات را غیرفعال کنید",
  Favorites: "علاقه‌مندی‌ها",
  "Cases about 1": "مورد خود را اضافه کنید",
  "Cases about 2":
    "موارد جالب را بررسی کنید، سوال بپرسید، تجربه به اشتراک بگذارید! تمامی موارد آپلود شده",
  "Cases about 3": "ناشناس خواهند شد",
  "Add case": "افزودن مورد",
  All: "همه",
  "I upload": "آپلود شده",
  drafts: "پیش‌نویس‌ها",
  draft: "پیش‌نویس",
  "Case v2": "مورد",
  "Open study": "باز کردن مطالعه",
  Comments: "نظرات",
  "Comment placeholder": "نوشتن نظر...",
  "Favorites about 1": "در حال حاضر چیزی اینجا نیست، روی آیکون کلیک کنید",
  "Favorites about 2":
    "در کنار مورد مورد علاقه برای اضافه کردن به علاقه‌مندی‌ها",
  "Comment screen info 1": "برای پیوست اسکرین‌شات، ",
  "Comment screen info 2": "مطالعه را در مرورگر باز کنید",
  Download: "دانلود",
  "Record Date": "تاریخ ضبط",
  "Request a course": "ثبت‌نام در دوره",
  "Request a course doned": "درخواست شما برای دوره ثبت شد",
  "Forgot password?": "رمز عبور را فراموش کرده‌اید؟",
  "Reset password": "بازیابی رمز عبور",
  "Reset password v2": "بازیابی رمز عبور",
  "Reset password about":
    "لطفاً آدرس ایمیلی که هنگام ثبت‌نام استفاده کرده‌اید را وارد کنید. دستورالعمل بازیابی برای شما ارسال خواهد شد",
  "Reset password about after": "لینک بازیابی رمز عبور به ایمیل ارسال شد",
  "Back to prev page": "بازگشت به صفحه قبلی",
  Email: "ایمیل",
  "Not valid email": "فرمت ایمیل نامعتبر است",
  EmailAlreadyRegistered: "ایمیل قبلاً ثبت شده است",
  NotActivatedAccount: "کاربر وجود دارد، اما حساب او هنوز فعال نشده است.",
  "Not found email": "ایمیل ثبت نشده است",
  "Back to login": "بازگشت به ورود",
  "Email not come?": "ایمیل دریافت نکردید؟",
  "Write to support": "تماس با پشتیبانی",
  "Create new password": "ایجاد رمز عبور جدید",
  "Password confirm": "تأیید رمز عبور",
  "Min 8": "حداقل ۸ کاراکتر",
  "Two inputs don't match!": "رمزها مطابقت ندارند",
  "Update password": "به‌روزرسانی رمز عبور",
  "Password updated": "رمز عبور با موفقیت به‌روزرسانی شد",
  "Invalid password token": "لینک نامعتبر است، لطفاً دوباره امتحان کنید",
  "Unknown user": "کاربر ناشناخته",
  "Attach image": "ضمیمه تصویر",
  Remove: "حذف",
  Complain: "گزارش",
  "Complain sent": "گزارش شما با موفقیت ارسال شد",
  owner: "نویسنده پرونده",
  assistant: "راهنما",
  "Answers 1": "پاسخ",
  "Answers 2": "پاسخ",
  "Answers 3": "پاسخ‌ها",
  "Add answer": "افزودن پاسخ",
  "Collapse answers": "بستن پاسخ‌ها",
  "Image only": "<تصویر>",
  "Cannot upload from mobile":
    "مطالعات را فقط از طریق رایانه می‌توان آپلود کرد",
  "Password rule": "رمز باید حداقل ۸ کاراکتر، شامل یک حرف لاتین و یک عدد باشد",
  ReferenceCursors: "C - نشانگر سه‌بعدی",
  "bad browser for mpr":
    "MPR ممکن است کار نکند. لطفاً از مرورگر Google Chrome استفاده کنید",
  "Service in process": "بارگذاری موقتاً در دسترس نیست",
  "Service in process about":
    "می‌توانید قابلیت‌های سرویس را با مثال‌هایی از مطالعات دمویی بررسی کنید. به شما اطلاع خواهیم داد که چه زمانی پردازش مطالعات ممکن خواهد بود.",
  "Edit case": "ویرایش مورد",
  Title: "عنوان",
  "Access count": "تعداد دسترسی",
  "Access count about":
    "در صورت انتخاب گزینه «برای همه»، انتشار برای همه قابل مشاهده خواهد بود. اگر دسترسی به صورت لینکی باشد، تنها از طریق لینک مستقیم قابل مشاهده است.",
  "To All": "برای همه",
  "To Link": "از طریق لینک",
  Publish: "انتشار",
  "Publish about":
    "در صورت انتشار ناشناس، نام و شرکت شما برای دیگر کاربران قابل مشاهده نخواهد بود.",
  How: "چگونه",
  "As Anon": "ناشناس",
  "Case accept": "من هیچ داده شخصی بیمار را منتشر نمی‌کنم.",
  "User Policy": "سیاست حفظ حریم خصوصی",
  "Remove case": "حذف مورد",
  "Save draft": "ذخیره پیش‌نویس",
  "Remove case success": "مورد با موفقیت حذف شد",
  "Remove case error": "حذف مورد ناموفق بود. لطفاً بعداً تلاش کنید",
  "Update case error": "به‌روزرسانی مورد ناموفق بود. لطفاً بعداً تلاش کنید",
  Edit: "ویرایش",
  "Cases v2": "موارد",
  sec: " ثانیه",
  "Confirm accept": "تأیید پذیرش",
  "Remove case?": "آیا سری حذف شود؟",
  "Upload AI": "آپلود مطالعه با فرمت DICOM",
  "Upload edu": "آپلود مورد با فرمت DICOM، JPEG یا PNG",
  "Upload community": "آپلود مورد با فرمت DICOM، JPEG یا PNG",
  "As anon": "ناشناس",
  status: {
    free: "رایگان",
    subscription: "با اشتراک",
    draft: "پیش‌نویس",
    archived: "بایگانی شده",
    completed: "تکمیل شده",
  },
  courseType: {
    course: "دوره",
    simulator: "شبیه ساز",
    webinar: "وبینار",
  },
  noAcceptResult: "لطفاً توضیح دهید با چه چیزی مخالف هستید",
  Meta: {
    tail: "%s | " + process.env.VUE_APP_INSTALL_NAME + "",
    tail2: " | " + process.env.VUE_APP_INSTALL_NAME + "",
    default: {
      title: "پلتفرم برای پزشکان",
      desc: process.env.VUE_APP_INSTALL_DESC,
    },
    "community-cases": {
      title: "انجمن پزشکی",
      desc: "جامعه حرفه‌ای آنلاین پزشکان برای بحث، سوال و تبادل تجربه!",
    },
    home: {
      title: "پلتفرم برای پزشکان",
      desc: "پلتفرم پزشکی آنلاین: دستیارهای هوش مصنوعی، شبیه‌سازها، دوره‌ها و منابع مفید برای پزشکان",
    },
    "ai-services": {
      title: "سرویس‌های هوش مصنوعی",
      desc: "سرویس‌های مبتنی بر هوش مصنوعی برای تشخیص بیماری‌ها",
    },
    "edu-services": {
      title: "پلتفرم آموزشی پزشکان",
      desc: "فهرست دوره‌های آموزشی و پایگاه دانش برای پزشکان تشخیصی",
    },
  },
  "Video is unavailable": "ویدیو در دسترس نیست",
  Licence:
    '© 2026 شرکت با مسئولیت محدود "پلتفرم ' +
    process.env.VUE_APP_INSTALL_NAME +
    '"، کلیه حقوق محفوظ است. 121205، مسکو، منطقه نوآوری اسکولکوفو، خیابان نوبل، ساختمان ۷، طبقه ۲، اتاق ۳۷، دفتر ۲',
  "Policy v2": "سیاست پردازش و حفاظت از داده‌های شخصی",
  "Site company": "وب‌سایت شرکت",
  homepage: {
    connect: "اتصال با ",
    cost: " / ماه",
    goToAI: "پردازش مطالعات",
    notAuthSub__off: {
      title: "دسترسی به تمامی قابلیت‌های دستیار هوش مصنوعی",
      desc: "دسترسی به دستیار هوش مصنوعی برای خودکارسازی اندازه‌گیری‌ها و تهیه گزارش",
    },
    notAuthSub__on: {
      title: "سرویس‌های هوش مصنوعی برای تحلیل تصاویر پزشکی",
      desc: "اندازه‌گیری‌ها را خودکار می‌کند و پروتکل معاینه را تولید می‌کند. ۳ معاینه را رایگان پردازش کنید، سپس — بیشتر با <PRICE>",
    },
    baseSub: {
      title: "خلاص شدن از روتین‌های تحلیل مطالعه با هوش مصنوعی",
      desc: "هوش مصنوعی اندازه‌گیری‌ها را انجام داده و با یک کلیک گزارش تولید می‌کند",
    },
    notBaseSub: {
      title: "بارگذاری تصویر با یک کلیک",
      desc: "از دستیار هوش مصنوعی برای خودکارسازی اندازه‌گیری‌ها و تهیه گزارش استفاده کنید",
    },
  },
  "Start type": "شروع به نوشتن...",
  buy: "خرید",
  more_details: "ادامه مطلب",
};
